/**
 * Agent-related constants
 */

/**
 * Maximum number of recent chats to display in the sidebar
 */
export const MAX_SIDEBAR_RECENT_CHATS = 30;

/**
 * AI Disclaimer text displayed below active chat inputs.
 * TD-1829: Centralized for easy updates and i18n support.
 */
export const AI_DISCLAIMER_TEXT =
  "transact's agent is AI and can make mistakes. Please check responses.";

/**
 * Layout constants for agent input component.
 * Used for calculating dynamic heights in multiline mode.
 */
export const AGENT_INPUT_LAYOUT = {
  /** Height threshold (px) for detecting multiline mode */
  SINGLE_LINE_HEIGHT_THRESHOLD: 30,
  /** Container padding: 12px top + 12px bottom */
  CONTAINER_PADDING: 24,
  /** Container border: 1px top + 1px bottom */
  CONTAINER_BORDER: 2,
  /** Default button row height (px) in multiline mode */
  BUTTON_ROW_HEIGHT_DEFAULT: 32
};
